// src/functions/noop/noop.ts
var noop = () => {
};

export {
  noop
};
